import Vue from "vue";
import Router from "vue-router";
import config from "@/config";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: () => import("@/views/default/index.vue"),
      children: [
        {
          path: "",
          redirect: "/login"
          // component: () => import("@/views/default/_home.vue")
        },
        {
          path: "/login",
          component: () => import("@/views/default/_login.vue")
        },
        {
          path: "/logout",
          component: () => import("@/views/default/_logout.vue")
        },
        {
          path: "/expired",
          component: () => import("@/views/default/_expired.vue")
        },
        {
          path: "/denied",
          component: () => import("@/views/default/_denied.vue")
        },
        {
          path: "/otp",
          component: () => import("@/views/default/_otp.vue")
        },
      ]
    },
    {
      path: "/system",
      component: () => import("@/views/system/index.vue"),
      children: [
        {
          path: "/system",
          redirect: "/system/page"
        },
        {
          path: "/system/function",
          component: () => import("@/views/system/_function.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.function] }
        },
        {
          path: "/system/page",
          component: () => import("@/views/system/_page.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.page] }
        },
        {
          path: "/system/role",
          component: () => import("@/views/system/_role.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.role] }
        },
        {
          path: "/system/user",
          component: () => import("@/views/system/_user.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.user] }
        },
        {
          path: "/system/setting",
          component: () => import("@/views/system/_setting.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.setting] }
        },
        {
          path: "/system/ip",
          component: () => import("@/views/system/_ip.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ip] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.function, config.accessRoles.page, config.accessRoles.role, config.accessRoles.user, config.accessRoles.setting, config.accessRoles.ip] }
    },
    {
      path: "/monitor",
      component: () => import("@/views/monitor/index.vue"),
      children: [
        {
          path: "/monitor",
          redirect: "/monitor/status"
        },
        {
          path: "/monitor/status",
          component: () => import("@/views/monitor/_status.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.asidebar] }
        },
        {
          path: "/monitor/omcache",
          component: () => import("@/views/monitor/_omcache.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.omcache] }
        },
        {
          path: "/monitor/sbomatch",
          component: () => import("@/views/monitor/_sboMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.sbomatch] }
        },
        {
          path: "/monitor/ibcmatch",
          component: () => import("@/views/monitor/_ibcMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ibcmatch] }
        },
        {
          path: "/monitor/cmdmatch",
          component: () => import("@/views/monitor/_cmdMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.cmdmatch] }
        },
        {
          path: "/monitor/statusaccount",
          component: () => import("@/views/monitor/_statusAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.asidebar] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.asidebar, config.accessRoles.omcache, config.accessRoles.sbomatch, config.accessRoles.ibcmatch, config.accessRoles.cmdmatch, ] }
    },
    {
      path: "/configuration",
      component: () => import("@/views/configuration/index.vue"),
      children: [
        {
          path: "/configuration",
          redirect: "/configuration/provider"
        },
        {
          path: "/configuration/host",
          component: () => import("@/views/configuration/_host.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.host] }
        },
        {
          path: "/configuration/provider",
          component: () => import("@/views/configuration/_provider.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.provider] }
        },
        {
          path: "/configuration/login",
          component: () => import("@/views/configuration/_login.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.login] }
        },
        {
          path: "/configuration/sbologin",
          component: () => import("@/views/configuration/_sboLogin.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.sbologin] }
        },
        {
          path: "/configuration/ibclogin",
          component: () => import("@/views/configuration/_ibcLogin.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ibclogin] }
        },
        // {
        //   path: "/configuration/cmdlogin",
        //   component: () => import("@/views/configuration/_cmdLogin.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.cmdlogin] }
        // },
        {
          path: "/configuration/bot",
          component: () => import("@/views/configuration/_bot.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bot] }
        },
        {
          path: "/configuration/sbobot",
          component: () => import("@/views/configuration/_sboBot.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.sbobot] }
        },
        {
          path: "/configuration/ibcbot",
          component: () => import("@/views/configuration/_ibcBot.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ibcbot] }
        },
        // {
        //   path: "/configuration/cmdbot",
        //   component: () => import("@/views/configuration/_cmdBot.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.cmdbot] }
        // },
        {
          path: "/configuration/proxy",
          component: () => import("@/views/configuration/_proxy.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.proxy] }
        },
        {
          path: "/configuration/jobcontrol",
          component: () => import("@/views/configuration/_jobControl.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.jobcontrol] }
        },
        {
          path: "/configuration/sport",
          component: () => import("@/views/configuration/_sport.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.sport] }
        },
        {
          path: "/configuration/jobcontrolsport",
          component: () => import("@/views/configuration/_jobControlSport.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.jobcontrolsport] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.host, config.accessRoles.provider, config.accessRoles.login, config.accessRoles.sbologin, config.accessRoles.ibclogin,
              config.accessRoles.bot, config.accessRoles.sbobot, config.accessRoles.ibcbot, config.accessRoles.proxy, config.accessRoles.jobcontrol, config.accessRoles.jobcontrolsport] }
    },
    {
      path: "/league",
      component: () => import("@/views/league/index.vue"),
      children: [
        {
          path: "/league",
          redirect: "/league/league"
        },
        {
          path: "/league/league",
          component: () => import("@/views/league/_league.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.league] }
        },
        {
          path: "/league/mapleague",
          component: () => import("@/views/league/_mapLeague.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.mapleague] }
        },
        {
          path: "/league/remapleague",
          component: () => import("@/views/league/_remapLeague.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.remapleague] }
        },
        {
          path: "/league/purgeleague",
          component: () => import("@/views/league/_purgeLeague.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgeleague] }
        },
        {
          path: "/league/purgeibcleague",
          component: () => import("@/views/league/_purgeIBCLeague.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgeibcleague] }
        },
        {
          path: "/league/purgesboleague",
          component: () => import("@/views/league/_purgeSBOLeague.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgesboleague] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.league, config.accessRoles.mapleague, config.accessRoles.purgeleague, config.accessRoles.purgeibcleague,
                                                      config.accessRoles.purgesboleague] }
    },
    {
      path: "/team",
      component: () => import("@/views/team/index.vue"),
      children: [
        {
          path: "/team",
          redirect: "/team/team"
        },
        {
          path: "/team/team",
          component: () => import("@/views/team/_team.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.team] }
        },
        {
          path: "/team/mapteam",
          component: () => import("@/views/team/_mapTeam.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.mapteam] }
        },
        {
          path: "/team/remapteam",
          component: () => import("@/views/team/_remapTeam.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.remapteam] }
        },
        {
          path: "/team/purgeteam",
          component: () => import("@/views/team/_purgeTeam.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgeteam] }
        },
        {
          path: "/team/purgeibcteam",
          component: () => import("@/views/team/_purgeIBCTeam.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgeibcteam] }
        },
        {
          path: "/team/purgesboteam",
          component: () => import("@/views/team/_purgeSBOTeam.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgesboteam] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.team, config.accessRoles.mapteam, config.accessRoles.purgeteam, config.accessRoles.purgeibcteam, config.accessRoles.purgesboteam] }
    },
    {
      path: "/match",
      component: () => import("@/views/match/index.vue"),
      children: [
        {
          path: "/match",
          redirect: "/match/match"
        },
        {
          path: "/match/match",
          component: () => import("@/views/match/_match.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.linkedmatch] }
        },
        {
          path: "/match/unmapmatch",
          component: () => import("@/views/match/_unmapMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.unmapmatch] }
        },
        {
          path: "/match/mapmatch",
          component: () => import("@/views/match/_mapMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.mapmatch] }
        },
        {
          path: "/match/mapmatchothers",
          component: () => import("@/views/match/_mapMatchOthers.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.mapmatchothers] }
        },
        {
          path: "/match/remapmatch",
          component: () => import("@/views/match/_remapMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.remapmatch] }
        },
        {
          path: "/match/mapoutright",
          component: () => import("@/views/match/_mapOutright.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.mapoutright] }
        },
        {
          path: "/match/updatemapping",
          component: () => import("@/views/match/_updateMapping.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.updatemapping] }
        },
        {
          path: "/match/preaddmatch",
          component: () => import("@/views/match/_preAddMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.preaddmatch] }
        },
        {
          path: "/match/purgematch",
          component: () => import("@/views/match/_purgeMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgematch] }
        },
        {
          path: "/match/matchclearrs",
          component: () => import("@/views/match/_matchClearRs.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.matchclearrs] }
        },
        {
          path: "/match/rsrtcontrol",
          component: () => import("@/views/match/_rsrtControl.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rsrtcontrol] }
        },
        {
          path: "/match/preaddmatchcmd",
          component: () => import("@/views/match/_preAddMatchCMD.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.preaddmatch] }
        },
        {
          path: "/match/preaddmatchibet",
          component: () => import("@/views/match/_preAddMatchIBET.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.preaddmatch] }
        },
        {
          path: "/match/cmdsbomapmatch",
          component: () => import("@/views/match/_cmdSBOMapMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.cmdsbomapmatch] }
        },
        {
          path: "/match/cmdsbomatch",
          component: () => import("@/views/match/_cmdSBOMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.cmdsbomatch] }
        },
        {
          path: "/match/outrightdoublematch",
          component: () => import("@/views/match/_outrightDoubleMatch.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.outrightdoublematch] }
        },
        {
          path: "/match/preaddmatchpending",
          component: () => import("@/views/match/_preAddMatchPending.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.preaddmatch] }
        },
        // {
        //   path: "/match/ibcibtmapmatch",
        //   component: () => import("@/views/match/_ibcIBTMapMatch.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ibcibtmapmatch] }
        // },
        // {
        //   path: "/match/ibcibtmatch",
        //   component: () => import("@/views/match/_ibcIBTMatch.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ibcibtmatch] }
        // },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.linkedmatch, config.accessRoles.mapmatch, config.accessRoles.preaddmatch] }
    },
    {
      path: "/log",
      component: () => import("@/views/log/index.vue"),
      children: [
        {
          path: "/log",
          redirect: "/log/actionlog"
        },
        {
          path: "/log/actionlog",
          component: () => import("@/views/log/_actionLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.actionlog] }
        },
        {
          path: "/log/leaguelog",
          component: () => import("@/views/log/_leagueLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.leaguelog] }
        },
        {
          path: "/log/teamlog",
          component: () => import("@/views/log/_teamLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.teamlog] }
        },
        {
          path: "/log/mapleaguelog",
          component: () => import("@/views/log/_mapLeagueLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.mapleaguelog] }
        },
        {
          path: "/log/mapteamlog",
          component: () => import("@/views/log/_mapTeamLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.mapteamlog] }
        },
        {
          path: "/log/purgeleaguelog",
          component: () => import("@/views/log/_purgeLeagueLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgeleaguelog] }
        },
        {
          path: "/log/purgeteamlog",
          component: () => import("@/views/log/_purgeTeamLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgeteamlog] }
        },
        {
          path: "/log/purgesbomatchlog",
          component: () => import("@/views/log/_purgeSBOMatchLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgesbomatchlog] }
        },
        {
          path: "/log/purgeibcmatchlog",
          component: () => import("@/views/log/_purgeIBCMatchLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgeibcmatchlog] }
        },
        {
          path: "/log/providerlog",
          component: () => import("@/views/log/_providerLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerlog] }
        },
        {
          path: "/log/matchlog",
          component: () => import("@/views/log/_matchLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.matchlog] }
        },
        {
          path: "/log/mapmatchlog",
          component: () => import("@/views/log/_mapMatchLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.mapmatchlog] }
        },
        {
          path: "/log/preaddmatchlog",
          component: () => import("@/views/log/_preAddMatchLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.preaddmatchlog] }
        },
        {
          path: "/log/purgematchlog",
          component: () => import("@/views/log/_purgeMatchLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.purgematchlog] }
        },
        {
          path: "/log/hostlog",
          component: () => import("@/views/log/_hostLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.hostlog] }
        },
        {
          path: "/log/loginlog",
          component: () => import("@/views/log/_loginLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.loginlog] }
        },
        {
          path: "/log/proxylog",
          component: () => import("@/views/log/_proxyLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.proxylog] }
        },
        {
          path: "/log/botlog",
          component: () => import("@/views/log/_botLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.botlog] }
        },
        {
          path: "/log/jobcontrollog",
          component: () => import("@/views/log/_jobControlLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.jobcontrollog] }
        },
        {
          path: "/log/sportlog",
          component: () => import("@/views/log/_sportLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.sportlog] }
        },
        {
          path: "/log/efightapilog",
          component: () => import("@/views/log/_efightAPILog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.efightapilog] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.actionlog, config.accessRoles.leaguelog, config.accessRoles.mapleaguelog] }
    },
    {
      path: "/rb",
      component: () => import("@/views/rb/index.vue"),
      children: [
        {
          path: "/rb",
          redirect: "/rb/dangerzone"
        },
        {
          path: "/rb/rtfcommentary",
          component: () => import("@/views/rb/_rtfCommentary.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rtfcommentary] }
        },
        {
          path: "/rb/dangerzone",
          component: () => import("@/views/rb/_dangerZone.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dangerzone] }
        },
        {
          path: "/rb/matchfeedOld",
          component: () => import("@/views/rb/_matchFeedOld.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.matchfeed] }
        },
        {
          path: "/rb/matchfeedOld/:matchId",
          component: () => import("@/components/matchFeed/matchDetailsOld.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.matchfeed] }
        },
        {
          path: "/rb/matchfeed",
          component: () => import("@/views/rb/_matchFeed.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.matchfeed] }
        },
        {
          path: "/rb/matchfeed/:matchId",
          component: () => import("@/components/matchFeed/matchDetails.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.matchfeed] }
        },
        {
          path: "/rb/dangerzonecorner",
          component: () => import("@/views/rb/_dangerZoneCorner.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dangerzone] }
        },
        {
          path: "/rb/dangerzonebooking",
          component: () => import("@/views/rb/_dangerZoneBooking.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dangerzone] }
        },
        {
          path: "/rb/dangerzonegoalkick",
          component: () => import("@/views/rb/_dangerZoneGoalKick.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dangerzone] }
        },
        {
          path: "/rb/rbdata",
          component: () => import("@/views/rb/_rbData.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rbdata] }
        },
        {
          path: "/rb/rbdata2",
          component: () => import("@/views/rb/_rbData2.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rbdata] }
        },
        {
          path: "/rb/repulldata",
          component: () => import("@/views/rb/_repullData.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rbdata] }
        },
        // {
        //   path: "/rb/matchfeed2",
        //   component: () => import("@/views/rb/_matchFeed2.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.matchfeed] }
        // },
        // {
        //   path: "/rb/matchfeed2/:gameId",
        //   component: () => import("@/components/matchFeed/matchDetails2.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.matchfeed] }
        // }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rtfcommentary, config.accessRoles.dangerzone, config.accessRoles.matchfeed, config.accessRoles.rbdata] }
    }
  ]
});

export default router;
